import { Link } from 'react-router-dom';

/**
 * Portada de administración. Solo la ve el rol ADMIN (ver `App`), y aun así el
 * backend vuelve a exigirlo en cada llamada a `/api/v1/admin/**`.
 *
 * Es un índice, no una pantalla con lógica: cada ABM vive en su módulo
 * (`src/usuarios` para KAN-143, `src/sistemas` para KAN-144) y esto solo dice
 * cuáles hay.
 */
export function Administracion() {
  return (
    <main>
      <h1>Administración</h1>
      <ul>
        <li>
          <Link to="/admin/usuarios">Usuarios</Link> — las personas que entran con email y
          contraseña.
        </li>
        <li>
          <Link to="/admin/sistemas">Sistemas conectados</Link> — las aplicaciones que emiten con
          una API key, con su rotación y la lista de tenants que cada una puede facturar.
        </li>
      </ul>
    </main>
  );
}
